import React from "react";

import { StyledButton } from "./styles";

interface ButtonProps {
    variant?: "contained" | "outlined" | "text";
    color?: "primary" | "neutral" | "danger";
    // compact (40px) — действие в строке таблицы: заметно ниже основной кнопки, но
    // остаётся полноценной зоной нажатия. small (32px) — для по-настоящему плотных мест.
    size?: "medium" | "compact" | "small";
    fontWeight?: number;
    fullWidth?: boolean;
    type?: "button" | "submit";
    // Событие прокидываем целиком: кнопке, открывающей поповер, нужен собственный якорь.
    onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
    disabled?: boolean;
    className?: string;
    children: React.ReactNode;
}

export const Button = ({
    variant = "contained",
    color = "primary",
    size = "medium",
    fontWeight,
    fullWidth,
    type = "button",
    onClick,
    disabled,
    className,
    children,
}: ButtonProps) => (
    <StyledButton
        $variant={variant}
        $color={color}
        $size={size}
        $fontWeight={fontWeight}
        $fullWidth={fullWidth}
        type={type}
        onClick={onClick}
        disabled={disabled}
        className={className}
    >
        {children}
    </StyledButton>
);
